
export type DepartmentId =
  | 'gm'  // 總經理室
  | 'fa'  // 財務部
  | 'ap'  // 行政人資部
  | 'it'  // 資訊部
  | 'lg'  // 法務部
  | 'sl1' // 業務一部
  | 'sl2' // 業務二部
  | 'li'  // 物流部
  | 'pt'  // 採購部
  | 'qc'  // 品保部
  | 'md'  // 行銷宣傳部
  | 'sys'; // 系統管理

export const DEPT_CODE_TO_NAME: Record<string, string> = {
  GM: "總經理室",
  FA: "財務部",
  AP: "行政人資部",
  IT: "資訊部",
  LG: "法務部",
  PT: "採購部",
  LI: "物流部",
  QC: "品保部",
  SL1: "業務一部",
  SL2: "業務二部",
  MD: "行銷宣傳部",
  SYS: "系統管理"
};

export const DEPARTMENTS = Object.entries(DEPT_CODE_TO_NAME).map(([code, name]) => ({
  id: code.toLowerCase(),
  code,
  name,
  email: `${code.toLowerCase()}@lg.app` // Mock email generation
}));

export const DEPARTMENT_OPTIONS = DEPARTMENTS.map(d => d.name);

// Helper: Get Name by Code (Case insensitive)
export function getDeptNameByCode(code: string | undefined | null): string {
  if (!code) return "未指定";
  const upper = code.toUpperCase();
  return DEPT_CODE_TO_NAME[upper] || code;
}

// Helper: Get Code by Name (Fuzzy)
export function getDeptCodeByName(name: string): string {
    const entry = Object.entries(DEPT_CODE_TO_NAME).find(([k, v]) => v === name);
    return entry ? entry[0] : "OTHER";
}
